import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Registrar Service Worker para funcionalidad PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registrado correctamente:', registration);
      })
      .catch((registrationError) => {
        console.log('Error al registrar Service Worker:', registrationError);
      });
  });
}
